import React from 'react'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  PropositionJockeyNameStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryResultsStyled,
  PropositionTrainerNameStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'

type Props = {
  summary: FieldSummary
}
export const TrotFieldSummaryResults: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryResultsStyled>
      <SelectionFormTableStyled>
        <PropositionJockeyNameStyled>
          <PropositionStrongFieldsStyled>D:</PropositionStrongFieldsStyled>
          <span className={summary.isRiderChanged ? 'rider-change fg-gray-lightest' : ''}>
            {summary.jockeyName?.toUpperCase()}
          </span>
        </PropositionJockeyNameStyled>
        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>{summary.trainerName}</span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryResultsStyled>
  )
}
